import {
  File,
  Image,
  Video,
  FileText,
  Presentation,
  FileSpreadsheet,
} from "lucide-react";
import type { FileType } from "../../types";
import { cn } from "@/shared/lib/cn";

interface FileIconProps {
  type: FileType;
  className?: string;
}

const iconMap = {
  image: Image,
  video: Video,
  document: FileText,
  presentation: Presentation,
  spreadsheet: FileSpreadsheet,
};

export function FileIcon({ type, className }: FileIconProps) {
  const Icon = iconMap[type] || File;
  return <Icon className={cn("h-5 w-5", className)} />;
}
